import { AxiosPromise } from "axios"
import { cvApi } from "./api"

export const patchOnboarding = (id: string): AxiosPromise =>
  cvApi(`/cv/${id}/onboarding`, {
    method: "PATCH"
  })
